export default "__VITE_ASSET__DwblCkVQ__"